var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopbarInfos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1236 -14) translate(0 -1) translate(1236 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#5f00a0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.7 9.76c0-.417.134-.841.403-1.27.269-.43.66-.785 1.176-1.067C10.794 7.14 11.395 7 12.082 7c.638 0 1.202.118 1.69.353.49.236.867.556 1.133.961.267.406.4.846.4 1.321 0 .375-.076.703-.228.985-.152.281-.332.525-.541.73-.21.204-.585.549-1.127 1.033-.15.137-.27.257-.36.36-.09.104-.157.198-.201.284-.044.086-.078.172-.102.258-.025.086-.061.236-.11.452-.083.458-.345.687-.785.687-.23 0-.422-.075-.578-.225-.157-.15-.235-.372-.235-.667 0-.37.057-.69.172-.96.114-.271.266-.51.456-.714.189-.205.444-.448.766-.73.282-.246.485-.432.61-.558.126-.125.232-.265.318-.42.086-.154.129-.32.129-.501 0-.353-.131-.65-.393-.892s-.6-.363-1.014-.363c-.485 0-.841.122-1.07.366-.23.245-.423.605-.581 1.08-.15.498-.434.747-.853.747-.246 0-.454-.087-.624-.261-.17-.174-.254-.363-.254-.565zM11.923 17c-.268 0-.503-.087-.703-.26-.2-.175-.3-.418-.3-.73 0-.278.096-.512.29-.7.194-.19.431-.285.713-.285.278 0 .511.095.7.284.19.19.284.423.284.7 0 .308-.099.55-.297.727-.198.176-.427.264-.687.264z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbarInfos);
export default __webpack_public_path__ + "static/media/topbar_infos.91ce2b83ff98d73ac8583955d061a2ad.svg";
export { ForwardRef as ReactComponent };